<div class="home" dir={{dir}}>
  <top-section></top-section>
  <quote></quote>
  <app-categories></app-categories>
  <new-products-section></new-products-section>
  <best-seller-section></best-seller-section>
  <app-map></app-map>
</div>
